<template>
  <div>
    <v-list-item
      :to="'/users/' + $store.getters['oauth/getUserId']"
    >
      <v-icon
        class="mr-3"
      >
        $manageUser
      </v-icon>
      <span>
        {{ $store.getters['oauth/getUserFullName'] }}
      </span>
    </v-list-item>
    <v-list-item
      @click="logout()"
    >
      <v-icon
        class="mr-3"
      >
        $logout
      </v-icon>
      {{ $t('base.logout') }}
    </v-list-item>
  </div>
</template>

<script>
    import {ACLMixin} from "@/app/mixins/ACLMixin";

    export default {
        name: "ToolbarUser",
        mixins: [ACLMixin],
        methods: {
            logout: function () {
                this.$store.commit('loader/overlay/show');
                this.$store.dispatch('time/stop');
                this.$store.dispatch('oauth/logout');
            }
        }
    };
</script>

<style scoped>

</style>
